/**
 * Product Form — Add to cart via Ajax
 */
(function () {
  'use strict';

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[data-add-to-cart]');
      this.submitText = this.querySelector('[data-add-to-cart-text]');
    }

    connectedCallback() {
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      /* Listen for variant changes to update button state */
      SixSeven.on(SixSeven.Events.VARIANT_CHANGED, (e) => {
        if (e.detail.sectionId !== this.dataset.section) return;
        this.updateButton(e.detail.variant);
        this.updatePrice(e.detail.variant);
      });
    }

    async handleSubmit(e) {
      e.preventDefault();

      if (this.submitButton.disabled) return;

      this.setLoading(true);

      const formData = new FormData(this.form);
      const items = [
        {
          id: parseInt(formData.get('id')),
          quantity: parseInt(formData.get('quantity') || 1),
        },
      ];

      try {
        await SixSeven.CartAPI.add(items);
        SixSeven.emit(SixSeven.Events.CART_ITEM_ADDED);
        SixSeven.emit('cart:toggle');
        this.setSuccess();
      } catch (error) {
        SixSeven.emit(SixSeven.Events.CART_ERROR, { message: error.message });
        this.setError(error.message);
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      this.submitButton.disabled = loading;
      this.classList.toggle('is-loading', loading);
    }

    setSuccess() {
      if (!this.submitText) return;
      const originalText = this.submitText.textContent;
      this.submitText.textContent = this.dataset.addedText || 'Added to cart';
      setTimeout(() => {
        this.submitText.textContent = originalText;
      }, 2000);
    }

    setError(message) {
      const errorEl = this.querySelector('[data-form-error]');
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
        setTimeout(() => {
          errorEl.hidden = true;
        }, 5000);
      }
    }

    updateButton(variant) {
      if (!this.submitButton || !this.submitText) return;

      if (!variant) {
        this.submitButton.disabled = true;
        this.submitText.textContent =
          this.dataset.unavailableText || 'Unavailable';
      } else if (!variant.available) {
        this.submitButton.disabled = true;
        this.submitText.textContent =
          this.dataset.soldOutText || 'Sold out';
      } else {
        this.submitButton.disabled = false;
        this.submitText.textContent =
          this.dataset.submitText || 'Add to cart';
      }
    }

    updatePrice(variant) {
      if (!variant) return;
      const priceEl = this.closest('[data-product-section]')?.querySelector(
        '[data-product-price]'
      );
      if (!priceEl) return;

      /* Reload section for price update via section rendering API */
      const sectionId = this.dataset.section;
      if (sectionId) {
        const url = `${this.dataset.productUrl || window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`;
        fetch(url)
          .then((res) => res.text())
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const newPrice = parsed.querySelector('[data-product-price]');
            if (newPrice && priceEl) {
              priceEl.innerHTML = newPrice.innerHTML;
            }
          });
      }
    }
  }

  customElements.define('product-form', ProductForm);

  /* Quantity selector logic (global) */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-quantity-minus]');
    const plus = e.target.closest('[data-quantity-plus]');

    if (!minus && !plus) return;

    const wrapper = (minus || plus).closest('.quantity-selector');
    const input = wrapper?.querySelector('[data-quantity-input]');
    if (!input) return;

    let value = parseInt(input.value) || 1;
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || 9999;

    if (minus) value = Math.max(min, value - 1);
    if (plus) value = Math.min(max, value + 1);

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    /* Update button states */
    const minusBtn = wrapper.querySelector('[data-quantity-minus]');
    const plusBtn = wrapper.querySelector('[data-quantity-plus]');
    if (minusBtn) minusBtn.disabled = value <= min;
    if (plusBtn) plusBtn.disabled = value >= max;
  });
})();
